<template>
  <div class="card-container">
    <div class="card">
      <img :src="image" alt="produto" class="product-img" />
      <div>
        <div class="title-info">
          <h4 class="title">{{ name }}</h4>
        </div>

        <div class="quantity-price has-pieces">
          <h4 class="quantity">1 unidade</h4>
<!--          <h4 class="price">Grátis</h4>-->
        </div>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productInfo: {
      required: true,
    },
  },
  data() {
    return {
      image: this.productInfo.images.l,
      name: this.productInfo.name,
    };
  },
};
</script>
